<div class="bonus-summary-container">
  <!-- Loading State -->
  <div class="summary-card loading-card" *ngIf="isLoading">
    <div class="loading-shimmer">
      <div class="shimmer-line"></div>
      <div class="shimmer-line"></div>
      <div class="shimmer-line"></div>
    </div>
  </div>

  <!-- Summary Card -->
  <div class="summary-card" *ngIf="!isLoading && summary">
    <div class="card-header">
      <div class="header-icon">
        <i class="fa-solid fa-chart-pie"></i>
      </div>
      <h2 class="card-title">{{ 'bonusPages.bonusSummary' | translate }}</h2>
    </div>

    <div class="summary-content">
      <!-- Total Bonus -->
      <div class="summary-item bonus-item">
        <div class="item-icon">
          <i class="fa-solid fa-gift"></i>
        </div>
        <div class="item-details">
          <span class="item-label">{{ 'bonusPages.totalBonus' | translate }}</span>
          <span class="item-value bonus-value">
            {{ summary.totalBonus | number:'1.0-0' }} {{ 'common.currency' | translate }}
          </span>
        </div>
      </div>

      <!-- Total Cashback -->
      <div class="summary-item cashback-item">
        <div class="item-icon">
          <i class="fa-solid fa-money-bill-trend-up"></i>
        </div>
        <div class="item-details">
          <span class="item-label">{{ 'bonusPages.totalCashback' | translate }}</span>
          <span class="item-value cashback-value">
            {{ summary.totalCashback | number:'1.0-0' }} {{ 'common.currency' | translate }}
          </span>
        </div>
      </div>

      <!-- Grand Total -->
      <div class="summary-item total-item">
        <div class="item-icon">
          <i class="fa-solid fa-coins"></i>
        </div>
        <div class="item-details">
          <span class="item-label">{{ 'bonusPages.grandTotal' | translate }}</span>
          <span class="item-value grand-total-value">
            {{ grandTotal | number:'1.0-0' }} {{ 'common.currency' | translate }}
          </span>
        </div>
      </div>

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Available for Withdrawal -->
      <div class="summary-item available-item">
        <div class="item-icon available-icon">
          <i class="fa-solid fa-hand-holding-dollar"></i>
        </div>
        <div class="item-details">
          <span class="item-label">{{ 'bonusPages.availableAmount' | translate }}</span>
          <span class="item-value available-value">
            {{ summary.availableForWithdrawal | number:'1.0-0' }} {{ 'common.currency' | translate }}
          </span>
        </div>
      </div>

      <!-- Withdraw Button -->
      <button 
        class="withdraw-button" 
        *ngIf="showWithdrawButton && canWithdraw"
        (click)="onWithdrawClick()">
        <i class="fa-solid fa-arrow-right-from-bracket"></i>
        {{ 'bonusPages.requestWithdrawal' | translate }}
      </button>

      <!-- No Withdrawal Available Message -->
      <div class="no-withdrawal-message" *ngIf="showWithdrawButton && !canWithdraw">
        <i class="fa-solid fa-info-circle"></i>
        <span>{{ 'bonusPages.noWithdrawalAvailable' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="summary-card empty-card" *ngIf="!isLoading && !summary">
    <div class="empty-state">
      <i class="fa-solid fa-chart-simple"></i>
      <p>{{ 'bonusPages.noSummaryData' | translate }}</p>
    </div>
  </div>
</div>
